import React from "react";

export type ControlledButtonHook = {
    disabled: boolean;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
};

export type OnClickHandlerType = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
) => Promise<unknown> | undefined;

export type ParamsType = {
    onClickHandler: OnClickHandlerType;
};

function useControlledButton({ onClickHandler }: ParamsType): ControlledButtonHook {
    const [disabled, setDisabled] = React.useState<boolean>(false);

    const onClick = React.useCallback(
        (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            setDisabled(true);

            const result = onClickHandler(event);

            if (result !== undefined) {
                result.finally(() => setDisabled(false));
            } else {
                setDisabled(false);
            }
        },
        [onClickHandler]
    );

    return React.useMemo(() => ({ disabled, onClick }), [disabled, onClick]);
}

export default useControlledButton;
